import { styled } from '@vebox/etui-system';
import { Children, isValidElement, cloneElement, createElement } from 'react';
import { a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import Step from './Step.js';

var StepsContainer = styled(Div)`
  display: flex;
  flex-direction: row;
`;

const StepsComponent = ({
  activeStep = 0,
  showNumbers = true,
  onChange,
  id = 'steps',
  styles = {},
  children
}) => {
  const onStepClick = next => {
    if (onChange && activeStep !== next) {
      onChange(next);
    }
  };
  const childrenArray = Children.toArray(children).filter(Boolean);
  const steps = childrenArray.map((step, index) => {
    if (typeof step === 'string' || typeof step === 'number') {
      throw new Error('Expecting component children to be of type StepProps');
    }
    if (/*#__PURE__*/isValidElement(step)) {
      const stepNumber = step.props.stepNumber || index + 1;
      const childProps = _objectSpread2({
        index,
        stepNumber,
        showNumbers,
        isCompleted: stepNumber < activeStep,
        isActive: stepNumber === activeStep,
        isLast: stepNumber === childrenArray.length,
        onStepClick: onChange && onStepClick
      }, step.props);
      return /*#__PURE__*/cloneElement(step, childProps);
    }
    return step;
  });
  return /*#__PURE__*/createElement(StepsContainer, _extends({
    id: id
  }, styles.root), steps);
};
var Steps = Object.assign(StepsComponent, {
  Step
});

export default Steps;
